// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2bYYR","active":"index-module--active--1NCNe"};